<template>
    <pre v-highlightjs="cleanedCode">
      <code :class="codeStyle"></code>
    </pre>
</template>

<script>
export default {
  name: 'HighlightBlockCode',
  props: {
    code: {
      type: String,
      required: true
    },
    showLineBreaks: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    codeStyle () {
      return this.showLineBreaks ? 'html show-line-breaks' : 'html'
    },
    cleanedCode () {
      let dirtyCode = this.code.split(/\r?\n/)
      let cleanedCode = []
      let isFirstLine = true
      let lastLineWithContent = 0
      let minimumInset = 999999

      for (let line of dirtyCode) {
        // check whether there are empty lines at the beginning
        if (isFirstLine && line.replace(/[^ -~]+/g, '') === '') {
          // continue
        } else {
          // update empty lines to be really empty
          if (line.replace(/[^ -~]+/g, '') === '') {
            line = ''
          } else {
            lastLineWithContent = cleanedCode.length + 1
          }

          // update minimum inset
          let lineInset = line.search(/\S/)
          if (lineInset < 0) {
            lineInset = 0
          }
          minimumInset = minimumInset < lineInset ? minimumInset : lineInset

          // add to cleaned code array
          cleanedCode.push(line)
          isFirstLine = false
        }
      }

      for (let i = 0; i < cleanedCode.length; i++) {
        let chars = cleanedCode[i].split('')
        chars.splice(0, minimumInset)
        cleanedCode[i] = chars.join('')
      }

      cleanedCode.splice(lastLineWithContent, cleanedCode.length - lastLineWithContent)
      return cleanedCode.join('\r\n')
    }
  }
}
</script>

<style lang="scss" scoped>
code.html.hljs.xml {
  padding: 16px;
  border-radius: 10px;
}
code.html.show-line-breaks {
  display: block;
  white-space: pre-wrap;
}
</style>



// WEBPACK FOOTER //
// src/components/HighlightBlockCode.vue